/** Dev-only UI (AI extraction debug panels, template dev mode, etc.) is gated on this role. */
export const isSuperAdmin = (role?: string | null): boolean => role === "super_admin";
